
export default {
  name: 'TransitionAccordion',
  methods: {
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.overflow = 'hidden'
    },
    endTransition (el) {
      el.style.height = ''
      el.style.overflow = ''
    }
  }
}
